/* istanbul ignore file */
import {createAxiosXhrInstance} from "@next/axios"

const axiosInstance = createAxiosXhrInstance()

export default axiosInstance
